document.addEventListener('DOMContentLoaded', function() {
  let buttonsInitialized = false;

  // Botones
  const btnComprar = document.getElementById('btn-vdv-proceso');
  const btnDisenador = document.getElementById('btn-vdv-proceso-diseñador');
  const panel = document.getElementById('vdv-panel-proceso');
  const overlay = document.getElementById('vdv-panel-overlay');
  const GraduacionAlta = document.getElementById('price-graduacion-alta');
  const btnSoloArmazon = document.getElementById('btn-vdv-proceso-armazon');
  // variables  
  let tracker = ''; //rastreador
  let tipoLente = ''; //paquete/personalizar
  let montoarmazon = 0;//precio armazon
  let selectedPaquetePrice = 0;//precio paquete
  let selectedArmazon = '';// Con/Sin graduacion
  let tipoGraduacion = '';//cliente/archivo/manual

  let ValorGraduacion = '';//alta/baja
  let montograduacion = 0;//precio graduacion alta/baja
  let totallente = 0;//subtotal

  // Tablas
  const tablagrd = jQuery('#w3-tabla-graduacion').html() || '';
  const tablagrd2 = jQuery('#w3-tabla-graduacion2').html() || '';
  
  // Precio base del armazón
  const NameArmazon = jQuery('h1.product-single__title').text();
  const priceText = jQuery('span.product-price__price span.money').first().text();
  montoarmazon = Number(
    priceText
        .replace(/\$/g, '')
        .replace(/,/g, '')
        .trim()
    ) || 0;
  totallente = montoarmazon;

  function checkCampos() {
    const GradBaja = document.querySelector('input[type=checkbox][value="Graduación baja"]');
    const GradAlta = document.querySelector('input[type=checkbox][value="Graduación alta"]');

     if (!GradBaja || !GradAlta) {
      return false;
    }
    
    if (!btnComprar) return false;
    btnComprar.disabled = false;

    panel.classList.add('is-visible');
    setupButtonClicks(GradBaja, GradAlta);
    return true;
  }
  function setArmazonValue(Grad) {
    if (!Grad) return;
    const inputArmazon = document.querySelector('input[name="properties[Armazón]"]');
    if (!inputArmazon) return;

    if (inputArmazon.value === Grad) {
      return;
    }
    const imgTarget = document.querySelector(`.div-armazon .image-picker-item[data-name="${CSS.escape(Grad)}"] .tip img`);
    if (!imgTarget) return;
    updateExtraDetail('armazon', 'Armazón', Grad);

    forceRealClick(imgTarget);
  }
  const EXTRA_ORDER = {
    producto: 1,
    paquete: 2,
    armazon: 3,
    graduacion: 7,
    subtotal: 8
  };
  function updateExtraDetail(key, label, value) {
    const container = jQuery('div#vdv-proceso-extra-detail #vdv-details-lente');
    if (!container.length) return;
    const selector = `.vdv-extra-item[data-key="${key}"]`;
    // Si no hay valor → eliminar
    if (!value) {
      container.find(selector).remove();
      return;
    }
    const order = EXTRA_ORDER[key] || 99;
    const html = `
      <div class="vdv-extra-item" data-key="${key}" data-order="${order}">
        <strong>${label}:</strong> ${value}
      </div>
    `;
    if (container.find(selector).length) {
      container.find(selector).replaceWith(html);
    } else {
      container.append(html);
    }
    const items = container.find('.vdv-extra-item').get();
    items.sort((a, b) => {
      return (
        parseInt(a.dataset.order, 10) -
        parseInt(b.dataset.order, 10)
      );
    });
    container.append(items);
  }
  function AddTextAndPrices(context = document) {
    function formatPrice(value) {
      return Number(value)
        .toFixed(0)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    jQuery(context).find('.tip').each(function () {
      const $tip = jQuery(this);
      const text = $tip.attr('data-tip');
      if (!text) return;
      if ($tip.data('textified')) return;
      $tip.data('textified', true);

      // === CONTENEDOR GENERAL ===
      const $infoDiv = jQuery('<div/>', {
        class: 'tip-info'
      });
      // === TEXTO ===
      const $textSpan = jQuery('<span/>', {
        class: 'tip-text',
        text: text
      });
      // === BUSCAR PRECIOS POR data-name ===
      const $priceContainer = jQuery(
        `#btn-vdv_micas_proceso-graduacion div[data-name="${text}"]`
      );

      let price = 0;
      let comparePrice = 0;
      if ($priceContainer.length) {
        price = parseFloat(
          $priceContainer.find('input[id^="price-"]').val()
        ) || 0;
        comparePrice = parseFloat(
          $priceContainer.find('input[id^="compare-price-"]').val()
        ) || 0;
      }

      // === PRECIOS ===
      const $pricesDiv = jQuery('<div/>', {
        class: 'tip-prices'
      });

      if (text == 'Personalizar') {
        $pricesDiv.append(
          jQuery('<span/>', {
            class: 'price-normal',
            text: `Precio variable`
          })
        );
      }
      else if (text == 'Con Graduación' || text == 'Sin Graduación') {
        $pricesDiv.append(
          jQuery('<span/>', {
            class: 'price-normal',
            text: ``
          })
        );
      }
      else {
        if (comparePrice > 0) {
          $pricesDiv.append(
            jQuery('<span/>', {
              class: 'price-compare',
              text: `$${formatPrice(comparePrice)}`
            })
          );
        }
        $pricesDiv.append(
          jQuery('<span/>', {
            class: 'price-normal',
            text: `$${formatPrice(price)}`
          })
        );
      }
      // === ARMAR ESTRUCTURA ===
      $infoDiv.append($textSpan);
      $infoDiv.append($pricesDiv);
      // === INSERTAR EN EL TIP ===
      $tip.append($infoDiv);
    });
  }
  function forceRealClick(element) {
    ['pointerdown', 'mousedown', 'mouseup', 'click'].forEach(type => {
      element.dispatchEvent(
        new MouseEvent(type, {
          view: window,
          bubbles: true,
          cancelable: true
        })
      );
    });
  }
  function formatCurrency(value) {
    const number = Number(value) || 0;
    return '$' + number
      .toFixed(0)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function observePaqueteChange() {
    const input = document.querySelector('input[name="properties[Paquetes]"]');
    if (!input) return;

    let lastValue = input.value;

    selectedPaquetePrice = 0;
    recalculateTotal();

    new MutationObserver(() => {
      if (tipoLente === 'SoloArmazon') return;
      if (input.value === lastValue) return;
      lastValue = input.value;
      selectedPaquetePrice = 0;

      if (!lastValue || lastValue.trim() === '') {
        updateExtraDetail('paquete', '', '');
        recalculateTotal();
        jQuery("#vdv-proceso-navi").addClass('hidden');
        jQuery("#vdv-proceso-navi-next").removeClass().attr('disabled', true).hide();
        return;
      }

      const tip = document.querySelector(`.tip[data-tip="${CSS.escape(lastValue)}"]`);
      if (!tip) {
        updateExtraDetail('paquete', '', '');
        recalculateTotal();
        jQuery("#vdv-proceso-navi").addClass('hidden');
        jQuery("#vdv-proceso-navi-next").removeClass().attr('disabled', true).hide();
        return;
      }
      const priceSpan = tip.querySelector('.price-normal');
      if (!priceSpan) {
        updateExtraDetail('paquete', '', '');
        recalculateTotal();
        jQuery("#vdv-proceso-navi").addClass('hidden');
        jQuery("#vdv-proceso-navi-next").removeClass().attr('disabled', true).hide();
        return;
      }

      selectedPaquetePrice = parseFloat(priceSpan.textContent.replace(/[^0-9]/g, '')) || 0;
      updateExtraDetail(
        'paquete',
        'Paquete',
        `${lastValue} (+${formatCurrency(selectedPaquetePrice)})`
      );

      recalculateTotal();

      const pickerItem = tip.closest('.image-picker-item');
      if (!pickerItem || !pickerItem.classList.contains('imagepicker-selected')) {
        return;
      }
      
        tipoLente = 'Paquete';
        if(tracker === '') tracker = tipoLente;
        ProcesoPaquete();

    }).observe(input, { attributes: true, attributeFilter: ['value']});
  }
  function observeArmazonChange() {
    const input = document.querySelector('input[name="properties[Armazón]"]');
    if (!input) return;

    const inputTratamiento = document.querySelector('input[name="properties[Tratamiento]"]');
    const divMica = jQuery("div.w3-product-options .div-mica"); 
    const divTratamiento = jQuery("div.w3-product-options .div-tratamiento");
    let lastValue = input.value;

    new MutationObserver(() => {
      if (tipoLente === 'SoloArmazon') return;
      if (input.value === lastValue) return;
      //if (tipoLente === 'Paquete') return;

      const previousArmazon = lastValue;
      const newArmazon = input.value;
      lastValue = newArmazon;
      
        const divGraduacion = jQuery("div#w3-tab-graduacion");
        const inputGraduacion = jQuery('div#w3-tab-graduacion input[name="properties[Graduacion]"]');
        
        const GradBaja = document.querySelector('input[type=checkbox][value="Graduación baja"]');
        const GradAlta = document.querySelector('input[type=checkbox][value="Graduación alta"]');
        
        let GraduacionVal = inputGraduacion.val();

        if (newArmazon === 'Con Graduación') {
          divGraduacion.removeClass("hide");
          if(GraduacionVal === '') {
            jQuery('div#w3-tabla-graduacion').html(tablagrd);
            jQuery('div#w3-tabla-graduacion2').html('');
            //jQuery('div#w3-tab-graduacion .picker-item[data-name="Subir Manual"] img').click();
            jQuery("div#proceso-vdv-form").hide();
          }
        }
        if (newArmazon === 'Sin Graduación') {
          montograduacion = 0;
          updateExtraDetail('graduacion','','');
          if(GraduacionVal != '') {
            jQuery('div#w3-tab-graduacion .picker-item[data-name="'+GraduacionVal+'"] img').click();
          }
          //inputGraduacion.val('').trigger('change');
          divGraduacion.addClass("hide");
          jQuery("div#proceso-vdv-form").show();
          jQuery('div#w3-tabla-graduacion').html('');
          jQuery('div#w3-tabla-graduacion2').html('');
          if (GradBaja?.checked) forceRealClick(GradBaja);
          if (GradAlta?.checked) forceRealClick(GradAlta);
        }
        updateExtraDetail('armazon', 'Armazón', newArmazon);
        recalculateTotal();

    }).observe(input, { attributes: true, attributeFilter: ['value'] });
  }
  function recalculateTotal() {
    totallente = montoarmazon + (selectedPaquetePrice || 0) + (montograduacion || 0);
    jQuery('#vdv-price-selected span').text(formatCurrency(totallente));
    updateExtraDetail(
      'subtotal',
      'Subtotal',
      formatCurrency(totallente)
    );
  }

  function setupButtonClicks(CheckGradBaja, CheckGradAlta) {
    if (buttonsInitialized) return;
    buttonsInitialized = true;
    AddTextAndPrices(document);
    observePaqueteChange();
    observeArmazonChange();// con/sin graduacion
    updateExtraDetail(
      'producto',
      'Lente',
      `${NameArmazon} (${formatCurrency(montoarmazon)})`
    );
    jQuery("#vdv-price-armazon span").text(formatCurrency(montoarmazon));
    // Abrir panel
    if (btnComprar) {
      btnComprar.addEventListener('click', function (e) {
        e.preventDefault();
        document.body.classList.add('vdv-panel-open');
        
        const inputPaquete = jQuery('div.div-paquetesVDV input[name="properties[Paquetes]"]').val();
        if(inputPaquete != '') return;
        jQuery("div.w3-product-options").show();
        jQuery(".div-paquetesVDV").removeClass('hide');
      });
    }
    if (btnSoloArmazon) {
      btnSoloArmazon.addEventListener('click', function(e) {
        e.preventDefault();
        tipoLente = 'SoloArmazon';
        Tracker();
      });
    }

    // Cerrar panel (overlay o X)
    function closePanel() {
      document.body.classList.remove('vdv-panel-open');
    }
    if (overlay) {
      overlay.addEventListener('click', closePanel);
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('.vdv-panel-close')) {
        e.preventDefault();
        closePanel();
      }
    });

    // --Seleccionar graduacion--
    jQuery("div#w3-tab-graduacion").on("click touchend", ".graduacion-items .picker-item img", function(e) {
      e.preventDefault();
      const clickedImg = jQuery(this);
      const parentItem = clickedImg.closest(".picker-item"); 
      const currentDesc = parentItem.find(".desc-item"); 
      const inputGraduacion = jQuery('div#w3-tab-graduacion input[name="properties[Graduacion]"]');
      tipoGraduacion = '';
      const isActive = parentItem.hasClass("pickeritem-selected"); 
      if (isActive) {
        parentItem.removeClass("pickeritem-selected");
        currentDesc.stop(true, true) .slideUp(200, function () { 
          jQuery(this).css("display", "none"); 
        }); 
        inputGraduacion.val('').trigger('change');
        jQuery("div#proceso-vdv-form").hide();
        return;
      }

      jQuery("div#proceso-vdv-form").show();
      jQuery("div#w3-tab-graduacion .picker-item").removeClass("pickeritem-selected");
      jQuery("div#w3-tab-graduacion .picker-item .desc-item").css("display", "none");
      
      parentItem.addClass("pickeritem-selected");
      currentDesc.stop(true,true).slideDown(20, function () { 
        jQuery(this).css("display", "block"); 
      }); 
      tipoGraduacion = parentItem.data('name'); 
      inputGraduacion.val(tipoGraduacion).trigger('change');
      if(tipoGraduacion === 'Subir Manual') {
        const div = document.querySelector('#w3-tabla-graduacion');
        if (div.children.length === 0) {
          jQuery('div#w3-tabla-graduacion').html(tablagrd);
          jQuery('div#w3-tabla-graduacion2').html('');
          updateExtraDetail('graduacion','','');
        }
      }
      if(tipoGraduacion === 'Consultado') {
        const div = document.querySelector('#w3-tabla-graduacion2');
        if (div.children.length === 0) {
          jQuery("#w3-ExamenForm").show();
          jQuery('div#w3-tabla-graduacion').html('');
          jQuery('div#w3-tabla-graduacion2').html(tablagrd2);  
          updateExtraDetail('graduacion','','');
        }
      }
      if(tipoGraduacion === 'Cargar Archivo') {
          jQuery('div#w3-tabla-graduacion').html('');
          jQuery('div#w3-tabla-graduacion2').html('');  
          updateExtraDetail('graduacion','','');
      }
    });
    //Regresar a div paquete
    jQuery("div#vdv-proceso-navi").on("click touchend", "#vdv-proceso-navi-back.back-div-paquetesVDV", function(e) {
      e.preventDefault();
      //jQuery("#vdv-proceso-navi").addClass('hidden');
      jQuery("#vdv-proceso-navi-back").removeClass().hide();
      jQuery("#vdv-proceso-subtotal").addClass('hidden');
      const divPaquete = jQuery("div.w3-product-options .div-paquetesVDV"); 
      const btnAddSoloArmazon = jQuery("button#btn-vdv-proceso-armazon"); 
      const divGraduacion = jQuery("div#w3-tab-graduacion");
      
      const divArmazon = jQuery("div.w3-product-options .div-armazon");// con/sin graduacion
        divPaquete.removeClass("hide");
        btnAddSoloArmazon.removeClass("hide");
        
        divArmazon.addClass("hide");
        divGraduacion.addClass("hide");
        jQuery("#vdv-proceso-navi-next").removeClass().addClass('next-div-graduacion').removeAttr('disabled').show();
        jQuery("div#proceso-vdv-form").hide();//btn carrito
        jQuery("div#vdv-proceso-extra-detail").hide();//resumen
      
    });
    //Siguiente a div Graduacion
    jQuery("div#vdv-proceso-navi").on("click touchend", "#vdv-proceso-navi-next.next-div-graduacion", function(e) {
      e.preventDefault();
      jQuery("#vdv-proceso-navi-back").removeClass();
      jQuery("#vdv-proceso-subtotal").addClass('hidden');
      const divPaquete = jQuery("div.w3-product-options .div-paquetesVDV"); 
      const btnAddSoloArmazon = jQuery("button#btn-vdv-proceso-armazon"); 
      const divGraduacion = jQuery("div#w3-tab-graduacion");      
      const divArmazon = jQuery("div.w3-product-options .div-armazon");// con/sin graduacion
      jQuery("#vdv-proceso-navi-next").removeClass().attr('disabled', true).hide();
      jQuery("div#proceso-vdv-form").show();
      divGraduacion.removeClass("hide");
        
        divPaquete.addClass("hide");
        btnAddSoloArmazon.addClass("hide");
        divArmazon.removeClass("hide");
        jQuery('div#vdv-proceso-extra-detail').show();
        jQuery("#vdv-proceso-navi-back").addClass('back-div-paquetesVDV').show();
      
    });
    /*
    //Siguiente a div Personalizar
    jQuery("div#vdv-proceso-navi").on("click touchend", "#vdv-proceso-navi-next.next-div-personalizar", function(e) {
      e.preventDefault();
      
        const inputArmazon = document.querySelector('input[name="properties[Armazón]"]');
        let ArmazonVal = inputArmazon.value;
        if(ArmazonVal == ''){
          jQuery("#vdv-proceso-navi-next").removeClass().attr('disabled', true).show();
        }

      ProcesoPersonalizar();
    });*/
    jQuery("div#w3-tabla-graduacion").on('change', '#EsferaOD, #EsferaOI, #CilindroOD, #CilindroOI', checkGraduacionesManual);
    // Función que comprueba graduacion
    function checkGraduacionesManual() {
      const selectEsferaOD = document.getElementById('EsferaOD')?.value.trim();
      const selectEsferaOI = document.getElementById('EsferaOI')?.value.trim();
      const selectCilindroOD = document.getElementById('CilindroOD')?.value.trim();
      const selectCilindroOI = document.getElementById('CilindroOI')?.value.trim();
      //console.log("ED:",selectEsferaOD," EI: ",selectEsferaOI," CD: ",selectCilindroOD," CI: ",selectCilindroOI);
      
      const inputGraduacion = jQuery('div.form-micas-grad input[name="properties[Graduación]"]');

      let esAlta = false;

      const checkEsfera = val => {
        if (!val || val === 'NA') return false;
        const num = parseInt(val.replace('+', ''));
        return num < -300 || num > 300;
      };

      const checkCilindro = val => {
        if (!val || val === 'NA') return false;
        const num = parseInt(val.replace('X', ''));
        return num <= -225;
      };

      esAlta =
        checkEsfera(selectEsferaOD) ||
        checkEsfera(selectEsferaOI) ||
        checkCilindro(selectCilindroOD) ||
        checkCilindro(selectCilindroOI);
        
      if (esAlta) {
        montograduacion = parseFloat(GraduacionAlta.value) || 0;
        updateExtraDetail(
          'graduacion',
          'Graduación',
          `Alta (+${formatCurrency(montograduacion)})`
        );
        recalculateTotal();

        if (CheckGradAlta?.checked) return;

        if (CheckGradBaja?.checked) forceRealClick(CheckGradBaja);
        if (CheckGradBaja) CheckGradBaja.checked = false;
        ValorGraduacion = 'Graduación alta';
        forceRealClick(CheckGradAlta);
        recalculateTotal();
        return;
      }
      if (CheckGradBaja && !CheckGradBaja.checked) {
        if (CheckGradAlta?.checked) forceRealClick(CheckGradAlta);
        ValorGraduacion = 'Graduación baja';
        forceRealClick(CheckGradBaja);
      }
      //if (CheckGradAlta) CheckGradAlta.checked = false;
      montograduacion = 0;

      updateExtraDetail(
        'graduacion',
        'Graduación',
        `Baja (+$0)`
      );
      recalculateTotal();
    }
    // Función que comprueba graduacion consulta
    jQuery(document).on(
      'keyup change',
      'div#w3-tab-graduacion .graduacion-items .picker-item[data-name="Consultado"] #fDay, ' +
      'div#w3-tab-graduacion .graduacion-items .picker-item[data-name="Consultado"] #fMonth, ' +
      'div#w3-tab-graduacion .graduacion-items .picker-item[data-name="Consultado"] #fYear',
      function (e) {

        const $container = jQuery(this).closest(
          'div#w3-tab-graduacion .graduacion-items .picker-item[data-name="Consultado"]'
        );
        const $day = $container.find('#fDay');
        const $month = $container.find('#fMonth');
        const $year = $container.find('#fYear');
        const id = this.id;
        let valor = this.value.replace(/\D/g, '');
        this.value = valor;

        function moverConExceso($actual, $siguiente, maxLength) {
          if (!valor) return;
          if (valor.length > maxLength) {
            const exceso = valor.substring(maxLength);
            $actual.val(valor.substring(0, maxLength));
            $siguiente.focus();
            if ($siguiente.val()) {
              $siguiente.select(); 
            }
            $siguiente.val(exceso); 
            return;
          }          
          if (valor.length === maxLength) {
            $siguiente.focus();
            if ($siguiente.val()) {
              $siguiente.select(); 
            }
          }
        }        
        if (id === 'fDay') {
          moverConExceso($day, $month, 2);
        }        
        if (id === 'fMonth') {
          moverConExceso($month, $year, 2);
        }        
        if (id === 'fYear') {
          if (valor.length > 4) {
            this.value = valor.substring(0, 4);
          }
        }
      }
    );
    jQuery('div#w3-tab-graduacion .graduacion-items .picker-item[data-name="Consultado"] span#btn-consulta-examen').click(function(){
                        
                const dayInput = document.getElementById("fDay");
                const monthInput = document.getElementById("fMonth");
                const yearInput = document.getElementById("fYear");

                if (!dayInput || !monthInput || !yearInput) return false;

                let day = parseInt(dayInput.value);
                let month = parseInt(monthInput.value);
                let year = parseInt(yearInput.value);

                if (isNaN(day) || isNaN(month) || isNaN(year)) {
                  alert("Completa los datos correctamente");
                  return false;
                }
                if (year < 1900 || year > new Date().getFullYear()) {
                  alert("Año inválido");
                  return false;
                }
                if (day < 1 || day > 31) {
                  alert("Día inválido");
                  return false;
                }
                if (month < 1 || month > 12) {
                  alert("Mes inválido");
                  return false;
                }
                const dayFormatted = day.toString().padStart(2, "0");
                const monthFormatted = month.toString().padStart(2, "0");
                const fechaConsulta = `${dayFormatted}/${monthFormatted}/${year}`;
                
                var cngrad_ed = 0; // esfera derecha
                var cngrad_ei = 0; // esfera izquierda
                var cngrad_cd = 0; // cilindro derecho
                var cngrad_ci = 0; // cilindro izquierdo
                
                const UrlCns = 'https://sistemavdv.com/sisv/Externo/Consultas/busquedaExamenPaciente2';
                jQuery.ajax({
                  url: UrlCns,
                  timeout:5000,
                  type: 'POST',
                  datatype: 'JSON',
                  data: {
                      Nombre: $("#fApellidoPaterno").val(),
                      Celular: $("#fCelular").val(),
                      FechaNacimiento: fechaConsulta,
                  },
                  beforeSend: function () {
                      $("#w3-ExamenPrecarga").show();
                      $("div#w3-tabla-graduacion2").hide();
                      $("#w3-response").html('');
                  },
                  success: function (datos) {
                      updateExtraDetail('graduacion','','');
                      if (datos.exito === true) {
                        $("div#w3-tabla-graduacion2").show();
                        $(" div#w3-tabla-graduacion2 #idCliente-c").val(datos.examen.PacienteId);
                        if($.trim(datos.examen.EsferaIzquierda)!=""){
                          $(" div#w3-tabla-graduacion2 #EsferaOI2").val(datos.examen.EsferaIzquierda);
                          $(" div#w3-tabla-graduacion2 #EsferaOI2t").val(datos.examen.EsferaIzquierda);
                          cngrad_ei=datos.examen.EsferaIzquierda;
                        }
                        else{
                          $(" div#w3-tabla-graduacion2 #EsferaOI2").val("NA");
                          $(" div#w3-tabla-graduacion2 #EsferaOI2t").val("NA");
                        }
                        if($.trim(datos.examen.EsferaDerecha)!=""){
                          $(" div#w3-tabla-graduacion2 #EsferaOD2").val(datos.examen.EsferaDerecha);
                          $(" div#w3-tabla-graduacion2 #EsferaOD2t").val(datos.examen.EsferaDerecha);
                          cngrad_ed=datos.examen.EsferaDerecha;
                        }
                        else{
                          $(" div#w3-tabla-graduacion2 #EsferaOD2").val("NA");
                          $(" div#w3-tabla-graduacion2 #EsferaOD2t").val("NA");
                        }
                        if($.trim(datos.examen.CilindroIzquierdo)!=""){
                          $(" div#w3-tabla-graduacion2 #CilindroOI2").val(datos.examen.CilindroIzquierdo);
                          $(" div#w3-tabla-graduacion2 #CilindroOI2t").val(datos.examen.CilindroIzquierdo);
                          cngrad_ci=datos.examen.CilindroIzquierdo;
                        }
                        else{
                          $(" div#w3-tabla-graduacion2 #CilindroOI2").val("NA");
                          $(" div#w3-tabla-graduacion2 #CilindroOI2t").val("NA");
                        }
                        if($.trim(datos.examen.CilindroDerecho)!=""){
                          $(" div#w3-tabla-graduacion2 #CilindroOD2").val(datos.examen.CilindroDerecho);
                          $(" div#w3-tabla-graduacion2 #CilindroOD2t").val(datos.examen.CilindroDerecho);
                          cngrad_cd=datos.examen.CilindroDerecho;
                        }
                        else{
                          $(" div#w3-tabla-graduacion2 #CilindroOD2").val("NA");
                          $(" div#w3-tabla-graduacion2 #CilindroOD2t").val("NA");
                        }
                        if($.trim(datos.examen.GradosIzquierdo)!=""){
                          $(" div#w3-tabla-graduacion2 #GradosOI2").val(datos.examen.GradosIzquierdo);
                          $(" div#w3-tabla-graduacion2 #GradosOI2t").val(datos.examen.GradosIzquierdo);
                        }
                        else{
                          $(" div#w3-tabla-graduacion2 #GradosOI2").val("NA");
                          $(" div#w3-tabla-graduacion2 #GradosOI2t").val("NA");
                        }
                        if($.trim(datos.examen.GradosDerecho)!=""){
                          $(" div#w3-tabla-graduacion2 #GradosOD2").val(datos.examen.GradosDerecho);
                          $(" div#w3-tabla-graduacion2 #GradosOD2t").val(datos.examen.GradosDerecho);
                        }
                        else{
                          $(" div#w3-tabla-graduacion2 #GradosOD2").val("NA");
                          $(" div#w3-tabla-graduacion2 #GradosOD2t").val("NA");
                        }
                        if($.trim(datos.examen.DistanciaIzq)!=""){
                          $(" div#w3-tabla-graduacion2 #DistanciaIP2").val(datos.examen.DistanciaIzq);
                          $(" div#w3-tabla-graduacion2 #DistanciaIP2t").val(datos.examen.DistanciaIzq);
                        }
                        else{
                          $(" div#w3-tabla-graduacion2 #DistanciaIP2").val("NA");
                          $(" div#w3-tabla-graduacion2 #DistanciaIP2t").val("NA");
                        }
                        if($.trim(datos.examen.Distancia)!=""){
                          $(" div#w3-tabla-graduacion2 #DistanciaD2").val(datos.examen.Distancia);
                          $(" div#w3-tabla-graduacion2 #DistanciaD2t").val(datos.examen.Distancia);
                        }
                        else{
                          $(" div#w3-tabla-graduacion2 #DistanciaD2").val("NA");
                          $(" div#w3-tabla-graduacion2 #DistanciaD2t").val("NA");
                        }
                        $("#w3-ExamenForm").hide();
                        $("#w3-ExamenPrecarga").hide();
                        checkGraduacionesConsulta(cngrad_ed,cngrad_ei,cngrad_cd,cngrad_ci);
                      }
                    else {
                      $("#w3-ExamenPrecarga").hide();
                      alert("No se encontró ningún paciente con los datos proporcionados, favor de comunicarse al número 800 225 4321");
                    }
                  },
                  // error: function (resultado) {
                  error: function () {
                    alert("No se encontró ningún paciente con los datos proporcionados, favor de comunicarse al número 800 225 4321");
                    jQuery("#w3-ExamenPrecarga").hide();
                  }
                });

    });
    function checkGraduacionesConsulta(cngrad_ed,cngrad_ei,cngrad_cd,cngrad_ci) {
      const selectEsferaOD = cngrad_ed;
      const selectEsferaOI = cngrad_ei;
      const selectCilindroOD = cngrad_cd;
      const selectCilindroOI = cngrad_ci;
      
      const inputGraduacion = jQuery('div.form-micas-grad input[name="properties[Graduación]"]');

      let esAlta = false;

      const checkEsfera = val => {
        if (!val || val === 'NA') return false;
        const num = parseInt(val.replace('+', ''));
        return num < -300 || num > 300;
      };

      const checkCilindro = val => {
        if (!val || val === 'NA') return false;
        const num = parseInt(val.replace('X', ''));
        return num <= -225;
      };

      esAlta =
        checkEsfera(selectEsferaOD) ||
        checkEsfera(selectEsferaOI) ||
        checkCilindro(selectCilindroOD) ||
        checkCilindro(selectCilindroOI);
        
      if (esAlta) {
        if (CheckGradAlta?.checked) return;

        if (CheckGradBaja?.checked) forceRealClick(CheckGradBaja);
        if (CheckGradBaja) CheckGradBaja.checked = false;
        montograduacion = parseFloat(GraduacionAlta.value) || 0;
        ValorGraduacion = 'Graduación alta';
        forceRealClick(CheckGradAlta);

        updateExtraDetail(
          'graduacion',
          'Graduación',
          `Alta (+${formatCurrency(montograduacion)})`
        );
        
        recalculateTotal();
        return;
      }
      if (CheckGradBaja && !CheckGradBaja.checked) {
        if (CheckGradAlta?.checked) forceRealClick(CheckGradAlta);
        ValorGraduacion = 'Graduación baja';
        //CheckGradBaja.checked = true;

        forceRealClick(CheckGradBaja);
      }
      //if (CheckGradAlta) CheckGradAlta.checked = false;
      montograduacion = 0;

      updateExtraDetail(
        'graduacion',
        'Graduación',
        `Baja (+$0)`
      );
      recalculateTotal();
    }
    jQuery('div#w3-tab-graduacion .graduacion-items .picker-item[data-name="Consultado"]').on('click touchend','#w3-tabla-graduacion2 span#btn-consulta-examen-re', function(e){
      e.preventDefault();
      jQuery("div#w3-tabla-graduacion2").hide();
      jQuery("#w3-ExamenForm").show();
      jQuery("div#w3-tab-graduacion .graduacion-items .picker-item[data-name='Consultado'] input").val('');
      jQuery("div#w3-tab-graduacion .graduacion-items .picker-item[data-name='Consultado'] select").prop('selectedIndex', 0);
      updateExtraDetail('graduacion','','');
    });

    //fin setupButtonClicks
  }
  function ProcesoPaquete() {
    Tracker();
    
    const divArmazon = jQuery("div.w3-product-options .div-armazon");// con/sin graduacion
    divArmazon.removeClass("hide");

    setArmazonValue('Con Graduación');
    jQuery("#vdv-proceso-navi").removeClass('hidden').addClass('last-div');
    jQuery("#vdv-proceso-navi-back").addClass('back-div-paquetesVDV').show();
    jQuery("#vdv-proceso-navi-next").removeClass().hide();
    //jQuery("#vdv-proceso-subtotal").removeClass('hidden');
    jQuery("div#vdv-proceso-extra-detail").show();
    const divPaquete = jQuery("div.w3-product-options .div-paquetesVDV"); 
    const btnAddSoloArmazon = jQuery("button#btn-vdv-proceso-armazon"); 
    const divGraduacion = jQuery("div#w3-tab-graduacion");
      divPaquete.addClass("hide");
      btnAddSoloArmazon.addClass("hide");
      divGraduacion.removeClass("hide");
      
    jQuery("div#proceso-vdv-form").show();
    const inputGraduacion = jQuery('div#w3-tab-graduacion input[name="properties[Graduacion]"]').val();
    if(inputGraduacion != '') return;
    jQuery('div#w3-tabla-graduacion').html(tablagrd);
    jQuery('div#w3-tabla-graduacion2').html('');
    jQuery('div#w3-tab-graduacion .picker-item[data-name="Subir Manual"] img').click();
  }
  function Tracker(){
    if(tipoLente === tracker) return;

    const inputPaquete = document.querySelector('input[name="properties[Paquetes]"]');
    const inputArmazon = document.querySelector('input[name="properties[Armazón]"]');
    const inputGraduacion = document.querySelector('input[name="properties[Graduacion]"]');
    
    const GradBaja = document.querySelector('input[type=checkbox][value="Graduación baja"]');
    const GradAlta = document.querySelector('input[type=checkbox][value="Graduación alta"]');

    let PaqueteVal = inputPaquete.value;
    let ArmazonVal = inputArmazon.value;
    let GraduacionVal = inputGraduacion.value;

    if(tipoLente === 'SoloArmazon'){
      let imgTarget = '';
      if (PaqueteVal !== ''){
        imgTarget = document.querySelector(`.div-paquetesVDV .image-picker-item[data-name="${CSS.escape(PaqueteVal)}"] .tip img`);
        if (imgTarget) forceRealClick(imgTarget);
      }
      if (ArmazonVal !== ''){
        imgTarget = document.querySelector(`.div-armazon .image-picker-item[data-name="${CSS.escape(ArmazonVal)}"] .tip img`);
        if (imgTarget) forceRealClick(imgTarget);
      }
      jQuery('div#w3-tabla-graduacion').html('');
      jQuery('div#w3-tabla-graduacion2').html('');
      if (GraduacionVal !== ''){
        if (GradBaja?.checked) forceRealClick(GradBaja);
        if (GradAlta?.checked) forceRealClick(GradAlta);
        jQuery('div#w3-tab-graduacion .picker-item[data-name="'+GraduacionVal+'"] img').click();
      }
      const addCartButton = document.querySelector('div#vdv-proceso-navi button.add-cart-btn.w3-options-add-to-cart');
        if (addCartButton) {
          const form = addCartButton.closest('form');
          if (form) {
            form.submit(); // MÁS SEGURO
          } else {
            addCartButton.click(); // fallback
          }
        }
      return;
    }
    if(tipoLente == 'Paquete'){ //tracker = personalizar
      tracker = tipoLente;
      if (!inputArmazon) return;
      let imgTarget = '';
      /*if (ArmazonVal !== ''){
        imgTarget = document.querySelector(`.div-armazon .image-picker-item[data-name="${CSS.escape(ArmazonVal)}"] .tip img`);
        if (imgTarget) forceRealClick(imgTarget);
      }*/
      if(GraduacionVal === '') return;
      jQuery('div#w3-tabla-graduacion').html('');
      jQuery('div#w3-tabla-graduacion2').html('');
      if (GraduacionVal !== ''){
        if (GradBaja?.checked) forceRealClick(GradBaja);
        if (GradAlta?.checked) forceRealClick(GradAlta);
        jQuery('div#w3-tab-graduacion .picker-item[data-name="'+GraduacionVal+'"] img').click();
        montograduacion = 0;
        recalculateTotal();
      }
    }

  }
  // Inicialización
  if (checkCampos()) return;
  const observer = new MutationObserver(() => {
    if (checkCampos()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});